import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { ImageModel } from '../models/image.model';

export class ImagesApiService extends ApiService {
  static endpoint = 'images';

  /**
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUrl(), {
      ...config,
      dataModel: ImageModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {string|number} id
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async get(id, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUrl(id), {
      ...config,
      dataModel: ImageModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {object} data
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildUrl(), data, {
      ...config,
      dataModel: ImageModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {string} url
   * @param {object} data
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async uploadFile(url, data, builderCallback = null, config = {}) {
    return HttpApiClient.put(url, data, {
      ...config,
      dataModel: ImageModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {string|number} id
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async delete(id, config = {}) {
    return HttpApiClient.delete(this.buildUrl(id), { ...config });
  }
}
